var map = {
	"./Adelaide/Adelaide.strings.json": [
		27239,
		7160
	],
	"./Conestoga/Conestoga.strings.json": [
		10811,
		7266
	],
	"./Melbourne/Melbourne.strings.json": [
		35163,
		6692
	],
	"./Monash/Monash.strings.json": [
		36073,
		3193
	],
	"./Nanyang/Nanyang.strings.json": [
		61343,
		6285
	],
	"./QUT/QUT.strings.json": [
		38287,
		9319
	],
	"./Sydney/Sydney.strings.json": [
		44369,
		6947
	],
	"./UP/UP.strings.json": [
		54871,
		2960
	],
	"./USC/USC.strings.json": [
		4051,
		2170
	],
	"./UTS/UTS.strings.json": [
		16647,
		5959
	],
	"./UWS/UWS.strings.json": [
		49691,
		4758
	],
	"./UniSA/UniSA.strings.json": [
		11615,
		6151
	],
	"./conestogatest/conestogatest.strings.json": [
		42919,
		8218
	],
	"./local/local.strings.json": [
		76987,
		1176
	],
	"./utsc/utsc.strings.json": [
		5843,
		4958
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47807;
module.exports = webpackAsyncContext;